/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChildMemoDto } from '../../models/child-memo-dto';

export interface UserChildMemoControllerAddSharedUser$Params {
  memoId: string;
  teacherUserId?: string;
  guardianUserId?: string;
  shareUserId: string;
}

export function userChildMemoControllerAddSharedUser(http: HttpClient, rootUrl: string, params: UserChildMemoControllerAddSharedUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ChildMemoDto>> {
  const rb = new RequestBuilder(rootUrl, userChildMemoControllerAddSharedUser.PATH, 'patch');
  if (params) {
    rb.path('memoId', params.memoId, {});
    rb.query('teacherUserId', params.teacherUserId, {});
    rb.query('guardianUserId', params.guardianUserId, {});
    rb.query('shareUserId', params.shareUserId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChildMemoDto>;
    })
  );
}

userChildMemoControllerAddSharedUser.PATH = '/api/child-memo/user/shared/{memoId}';
